import React, { Fragment } from 'react';
import { BannerTypes } from '@gin-betting/banners';
import LazyImage from '@gin-betting/components/lazy-image';
import core from '@gin-betting/core';
import cn from 'classnames';

import { Action, useAnalyticAttrs } from 'services/analytics';
import features from 'services/feature-manager';

import './bannersImage.scss';

const {
    utils: { getBettingOptions },
} = core;

interface Props {
    banner: BannerTypes.BannerInfo;
}

const BannerImage: React.FC<Props> = ({ banner }) => {
    const {
        imageHref,
        imageSrc: bannerSrc,
        title,
        buttonHref,
        buttonText,
        id,
    } = banner;

    const isButtonBackgroundNew = features.isActive(
        features.list.BannerButtonBackground
    );

    const analyticAttrs = useAnalyticAttrs();

    if (!bannerSrc) return null;

    const { locale } = getBettingOptions();
    const eventLabel = `[${locale}] ${id}`;

    return (
        <div styleName="container" className="__app-Banners-container">
            <div styleName="list">
                <LazyImage url={bannerSrc} isFullSize={true}>
                    {({ url, ref }) => {
                        return (
                            <Fragment>
                                <a
                                    ref={ref}
                                    href={imageHref}
                                    styleName="item"
                                    title={title}
                                >
                                    {url && (
                                        <img
                                            styleName="img"
                                            className="__app-BannerImage-img"
                                            src={url}
                                            alt={title}
                                            {...analyticAttrs}
                                            data-action={Action.ClickOnImage}
                                            data-label={eventLabel}
                                        />
                                    )}
                                </a>
                                {!!buttonText && url && (
                                    <a
                                        styleName={cn('button', {
                                            'button-new': isButtonBackgroundNew,
                                        })}
                                        {...analyticAttrs}
                                        data-action={Action.ClickOnButton}
                                        data-label={eventLabel}
                                        href={buttonHref || imageHref}
                                    >
                                        {buttonText}
                                    </a>
                                )}
                            </Fragment>
                        );
                    }}
                </LazyImage>
            </div>
        </div>
    );
};

export default React.memo(BannerImage);
